import React from 'react';
import { motion } from 'framer-motion';
type Badge = {
  text: string;
  top?: string;
  left?: string;
  right?: string;
  bottom?: string;
  centerX?: boolean;
  delay: number;
};
const badges: Badge[] = [{
  text: '72HS',
  top: '8%',
  left: '-5%',
  delay: 0
}, {
  text: 'PREMIUM UI',
  top: '18%',
  left: '-6%',
  delay: 2
}, {
  text: 'SEO READY',
  top: '45%',
  right: '-10%',
  delay: 1.5
}, {
  text: 'WHATSAPP',
  bottom: '38%',
  left: '-8%',
  delay: 0.5
}];
export function FloatingBadges() {
  return <>
      {badges.map((badge, i) => <motion.div key={i} className="absolute hidden md:flex items-center justify-center px-4 py-1.5 rounded-full bg-white/5 backdrop-blur-md border border-white/10 shadow-[0_0_15px_rgba(255,255,255,0.05)] z-20 whitespace-nowrap" style={{
      top: badge.top,
      left: badge.centerX ? '50%' : badge.left,
      right: badge.right,
      bottom: badge.bottom,
      transform: badge.centerX ? 'translateX(-50%)' : undefined
    }} animate={{
      y: [-10, 10, -10]
    }} transition={{
      duration: 5 + Math.random() * 2,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: badge.delay
    }} data-id="element-124">
          <span className="text-[10px] font-bold tracking-wider text-neutral-300 uppercase" data-id="element-125">
            {badge.text}
          </span>
        </motion.div>)}
    </>;
}